module.exports = __webpack_public_path__ + "static/brochure-e15b1835b17133e2eeb5d0cb20435108.png";